import { render, staticRenderFns } from "./CardTicket.vue?vue&type=template&id=b2eda870&scoped=true&"
import script from "./CardTicket.vue?vue&type=script&lang=js&"
export * from "./CardTicket.vue?vue&type=script&lang=js&"
import style0 from "./CardTicket.vue?vue&type=style&index=0&id=b2eda870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eda870",
  null
  
)

export default component.exports